var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,class:item.active ? 'item  active':'item',on:{"click":function($event){return _vm.$router.push(item.href)}}},[_vm._v("\n      "+_vm._s(item.text)+"\n   ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }